import React, { useState, memo } from 'react';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import { isMobileView } from '../../Common/utils';
import { calculateDaysToTrip, convert_yyyymmdd_to_dd_mm_dddd, ctaHelper, CTA_TYPE, getDate, trackActionEvent } from '../../../utils/Omniture';
import { useSelector } from 'react-redux';
import { routeDataSelector } from '../../RoutePage/redux/selectors';
//import MWebCalendar from '../../CommonResp/CalendarMWEB/MWebCalendar/MWebCalendar' //BUS-2625 remove calendar on rtc click
function RTCCard(props) {
    
    const { rtcBuses, moveToFunnel, showClientContent } = props;
    // const [showMwebCal, setShowMwebCal] = useState(false) //BUS-2625 remove calendar on rtc click
    const [rtcId, setRTCId] = useState(0)
    let view = [];
    const mobileView = isMobileView();
    const height = mobileView ? "48px" : "71px";
    const width = mobileView ? "48px" : "71px";
    const data = useSelector(routeDataSelector);
    const {src, dest, src_id, dest_id} = data
    //BUS-2625 remove calendar on rtc click
    // const changeCalendar = () => {
    //     setShowMwebCal(!showMwebCal)
    // }    
    const track = ()=>{
        const { date,src_state_name, dest_state_name } = data;
        const selectedDate = getDate(date);
        const buses = rtcBuses[Object.keys(rtcBuses)[0]];
        const eventDetails = {
            search: {
                searchId: `${src}_${dest}_${date}`,
                noOfGovtBusResults:  `${buses?.onw?.busCount}`
            },
            cta: ctaHelper(['View_Buses', CTA_TYPE.BUTTON, 'Header', 'SRP']),
            booking: {
                routeCity: `${src}-${dest}`,
                routeState: `${src_state_name}-${dest_state_name}`,
                daysToTrip: calculateDaysToTrip(selectedDate),
                departureDate: convert_yyyymmdd_to_dd_mm_dddd(date),
            },
        };
        trackActionEvent("ShowBuses",eventDetails,{gloabl:true})
    }
    for (let rtcid in rtcBuses) {
        const { f_name, img_url, name, opid, onw, op_url, msg } = rtcBuses[rtcid];
        const { busCount, cheapest_price, seatCount, earliest_departure } = onw;
        const {title = ""} = msg   
        const operatorUrl = function () {
            if (op_url) {
                return `${__ENV_CONFIG__.__GOIBIBO__}${op_url}`;
            }
            return '';
        }();
        if (busCount > 0) {
            view.push(
                <tr className="seoListingTable firstRowList relative rtcListingMobile" key={f_name + opid}>
                    <td className="firstList">
                        <div className="travellerInfoSection">
                            <div className="makeFlex rtcFlexMobile">
                                <div className="travelerImg">
                                    {showClientContent ? <img key={opid + f_name} data-src={img_url} className="lazyload" alt='rtc' style={{ width: width, height: height }} /> : null}
                                </div>
                                <div className="flexOne rtcBus rtcBusForCard ">
                                    <p className="travelAgency truncatelistHeading">{operatorUrl ? <a className="interlinkcardHeading" href={operatorUrl}>{name}</a> : <>{name}</>}
                                    </p>

                                    <p className="busType desktopOnly">{f_name}</p>
                                    <p className="busesCount busesCountMobile">{`${busCount} buses`}</p>
                                    {title && <div className="discountTag">
                                        <span dangerouslySetInnerHTML={{ __html: title }} onClick={() => {
                                            moveToFunnel({ page: 'srp', rtcId: rtcid, rtcOfferClick: true })
                                        }} />
                                     </div>}
                                </div>
                            </div>

                        </div>
                    </td>
                    <td>
                        <div className="busInfo">
                            <>
                                {earliest_departure ? <p>{`Starts at ${earliest_departure}`}</p> : null}
                                {false ? <p>Duration: 6h 30m - 9h 40m</p> : null}
                            </>
                        </div>
                    </td>
                    <td>
                        <p className="price">{` ₹${cheapest_price}`}</p>
                        <p className="orgPrice">Starts from</p>
                    </td>
                    <td className="firstListBtn">
                        <div className="desktopOnly">
                            <p className="busesInfo">{`${busCount} Buses`}</p>
                            <p className="seatLeft appendBottom5">{`${seatCount} seats left`}</p>
                            <span className="selectSeat show marginBottom0" style={{ cursor: 'pointer' }} onClick={() => {
                               track();
                               moveToFunnel({ page: 'srp', rtcId: rtcid });
                            }}>SHOW BUSES</span>
                        </div>
                        <div className="mobileOnly busesInfoSection rtcCardMobileOnly">
                            <p className="busesInfoMobile">{`From ₹${cheapest_price}`}</p>
                            <span className="showBusBtn showBusBtnBusCard" onClick={() => {
                                console.log('onClick working')
                              track();
                              moveToFunnel({ page: 'srp', rtcId: rtcid })
                              setRTCId(rtcId)
                            //   moveToFunnel({ page: 'srp', rtcId: rtcid });
                            }}>{`View all `}<span className="downArrow"></span></span>
                        </div>
                    </td>
                </tr>
            )
        }
    }
    //BUS-2625 remove calendar on rtc click
    // {showMwebCal &&
    //     view.splice(0, 0, <MWebCalendar showCalendar={showMwebCal} moveToFunnelParams={{ rtcId, src, dest, src_id, dest_id}} changeCalendar={changeCalendar} page={'srp'} isBusCard={'rtc'} />)
    // }
    return (
        <>
            {view}
        </>
    )
}

export default memo(RTCCard)
